import clsx from 'clsx';
import { ReactNode } from 'react';
import { useHapticFeedback } from '@bitbot/shared/bridge';

export const ButtonType = {
  primary: 'bg-btn-primary text-primary active:bg-btn-active',
  disabled: 'bg-btn-disable text-quaternary',
  normal: 'bg-white text-black',
  secondary: 'bg-btn-secondary text-reverse  active:opacity-80',
  tertiary: 'bg-tertiary text-primary',
  border: 'bg-transparent border-[1px] border-primary',
};

export const SizeType = {
  xs: 'h-[48px] rounded-[16px] ',
  sm: 'h-[52px] rounded-[18px] ',
  normal: 'h-[58px] rounded-[18px] ',
};

export function Button({
  children,
  onClick,
  type = 'primary',
  size = 'normal',
  className,
}: {
  children: ReactNode | string;
  onClick: () => void;
  type?: keyof typeof ButtonType;
  size?: keyof typeof SizeType;
  className?: string;
}) {
  const hapticFeedback = useHapticFeedback();
  return (
    <div className="w-full active:scale-[0.97] transition-all duration-200 text-lg">
      <button
        className={clsx(
          ButtonType[type],
          SizeType[size],
          className,
          'relative flex items-center justify-center w-full font-bold outline-none leading-[1.5] tracking-[-0.16px] px-[16px]',
        )}
        onClick={() => {
          onClick();
          hapticFeedback?.impactOccurred('medium');
        }}
      >
        {children}
        {/* <div className="active:scale-[1.0309278] w-full h-full transition-all duration-200 flex items-center justify-center">
        </div> */}
      </button>
    </div>
  );
}
